<template>
  <div :class="{ auth: true, 'b2b-layout': isB2B && hasB2BContent }">
    <div v-if="isB2B && hasB2BContent" class="b2b-content">
      <h2 v-if="b2bContent.loginHeader">{{ b2bContent.loginHeader }}</h2>
      <div class="img-container">
        <img v-if="b2bContent.loginImage" :src="b2bImage" alt="B2B Login page image" />
      </div>
      <p v-if="b2bContent.loginText">{{ b2bContent.loginText }}</p>
    </div>
    <center-layout>
      <template #heading>
        <div class="auth__heading">
          <img v-if="isB2B && b2bContent.logo" :src="b2bLogo" alt="Platform logo" />
          <img
            v-else-if="oezPlatformName === 'Foodrazor'"
            src="@/assets/Foodrazor-logo.svg"
            alt="Foodrazor logo"
          />
          <img v-else src="@/assets/logo-dark.svg" alt="EZ logo" />
        </div>
      </template>
      <ez-form
        class="auth__form"
        :showLoader="false"
        :formKey="formKey"
        :action="action"
        :method="method"
        :additionalData="additionalData"
        :submitType="submitType"
        @success="onSuccess"
        @error="onError"
      >
        <slot name="title"></slot>
        <slot></slot>
      </ez-form>
    </center-layout>
  </div>
</template>

<script>
import EzForm from '@/components/ui/Form';
import CenterLayout from '@/components/layout/Center.vue';

export default {
  components: {
    CenterLayout,
    EzForm,
  },
  props: {
    action: {
      type: String,
      required: true,
    },
    method: {
      type: String,
      required: false,
      default: 'post',
    },
    formKey: {
      type: String,
      required: true,
    },
    additionalData: {
      type: Object,
      required: false,
    },
    submitType: {
      type: String,
      required: false,
    },
    onSuccess: {
      type: Function,
      required: false,
    },
    onError: {
      type: Function,
      required: false,
      default: () => {},
    },
    b2bContent: {
      type: Object,
      required: false,
      default: () => {},
    },
  },
  computed: {
    oezPlatformName() {
      return process.env.VUE_APP_PLATFORM_TITLE;
    },
    isB2B() {
      return this.b2bContent?.active || false;
    },
    hasB2BContent() {
      return (
        !!this.b2bContent?.loginHeader ||
        !!this.b2bContent?.loginText ||
        !!this.b2bContent?.loginImage ||
        false
      );
    },
    b2bLogo() {
      return `${process.env.VUE_APP_API_URL}/public/b2b-portal/${this.b2bContent?.domain}/logo`;
    },
    b2bImage() {
      return `${process.env.VUE_APP_API_URL}/public/b2b-portal/${this.b2bContent?.domain}/login-image`;
    },
  },
};
</script>

<style lang="scss" scoped>
$primary-color: #4d7cfe;
$label-color: #8790a3;
$default-color: #252631;
$text-color: #6c7995;

.auth {
  width: 100%;
  height: 100%;
  &__heading {
    @extend %flex-center;
    justify-content: center;
    flex-wrap: wrap;
    padding: 5rem 0 1rem 0;
    margin: 0 auto;
    width: 7.75rem;
    display: block;
    span {
      @include font-size(20px);
      color: $label-color;
      margin-left: 0.5rem;
    }
    img {
      width: 100%;
      height: auto;
    }
  }
  :deep() &__form {
    margin: 0 auto;
    h1 {
      @include font-size(24px);
      font-weight: 500;
      text-align: center;
      margin: 0;
    }
    a {
      display: block;
      color: $primary-color;
      text-align: center;
      text-decoration: none;
      margin-top: 1.5rem;
      @include font-size(14px);
    }
    p {
      @include font-size(14px);
      color: $text-color;
      text-align: center;
      line-height: 1.75;
      margin: 0.5rem 0 2rem 0;
      a {
        display: inline-block;
        color: $text-color;
        text-decoration: underline;
      }
    }
    button {
      margin-top: 1rem;
    }
    :deep() .input-group {
      width: 100%;
      + .input-group {
        margin-top: 1rem;
      }
      &__input {
        height: 2.5rem;
      }
    }
  }

  &.b2b-layout {
    padding: 48px;
    padding-top: 0;
    height: auto;
    margin: 0 auto;
    margin-top: 128px;
    display: flex;
    max-width: 1256px;
    align-items: center;

    :deep() .layout-center {
      padding-left: 48px;
      border-left: 1px dashed #e1e5ed;
      .layout-center__heading .auth__heading {
        padding: 0;
        padding-bottom: 1rem;
      }
    }
    .b2b-content {
      margin-right: 48px;
      display: flex;
      flex-direction: column;
      align-items: center;
      flex-shrink: 1;

      p {
        font-weight: 500;
        font-size: 18px;
        line-height: 1.4;
        text-align: center;
        padding: 0 48px;
      }
      .img-container {
        max-width: 700px;
        width: 100%;
        max-height: 50vh;
        img {
          border-radius: 5px;
          max-width: 100%;
          max-height: 100%;
        }
      }

      h2 {
        font-size: 32px;
        margin: 0;
        & + .img-container {
          margin-top: 48px;
        }
        & + p {
          margin: 0;
          margin-top: 48px;
        }
      }

      .img-container + p {
        margin: 0;
        margin-top: 48px;
      }
    }

    @media (max-width: 768px) {
      :deep() .layout-center {
        padding-left: 0;
        border-left: none;
      }
      flex-direction: column;
      .b2b-content {
        margin-right: 0;
        h2 {
          margin-bottom: 24px;
        }
        .img-container,
        p {
          display: none;
        }
      }
    }
  }
}
</style>
